<template>
  <main class="addedServicesPg">
    <h6 class="mb-0 p-2 primaryBg whiteText mb-3">
      Service Items
    </h6>

    <div class="row">
      <div v-for="(item, index) in services" :key="index" class="col-lg-6 col-md-6 col-sm-12 col-12">
        <div :id="'service-' + index" class="electricSec">
          <h6 class="mb-0 d-flex align-items-center justify-content-between p-2 lightGreyBg rounded mb-3">
            <span class="d-flex align-items-center">
              <img v-if="item.value == 3" src="../../assets/images/electric-head-icon.png" alt="electric-head-icon"
                class="me-2">
              <img v-if="item.value == 2" src="../../assets/images/duck-head-icon.png" alt="electric-head-icon"
                class="me-2">
              {{ item.option }}
            </span>
            <span class="d-flex align-items-center gap-[10px] shrink-0">
              <img src="../../assets/images/edit-icon-4.png" alt="edit" class="w-[28px] cursor-pointer"
                @click="$emit('edit', index)">
              <img src="../../assets/images/trash-icon.png" alt="remove" class="w-[28px] cursor-pointer"
                @click="$emit('remove', index)">
            </span>
          </h6>

          <div class="form-group mb-3">
            <label class="mb-1">Select Service</label>
            <div class="d-flex align-items-start justify-content-between">
              <div class="w-100 me-2">
                <select v-model="item.selected_service" class="form-select me-3" aria-label="Default select example"
                  @change="onChange(item)">
                  <option :value="null" disabled>
                    Select Service
                  </option>
                  <option v-for="(opt, idx) in getBookingActions(item.value)" :key="idx" :value="opt"
                    :selected="item.selected_service != null && opt.id == item.selected_service.id">
                    {{ opt.new_display_name }}
                  </option>
                </select>
                <small v-if="item.is_error" class="text-danger fw-bold">
                  {{ item.error }}
                </small>
                <!-- service warranty -->
                <div class="serviceWarranty mt-2 mb-4">
                  <div class="form-group">
                    <div class="form-check d-flex p-0">
                      <div class="form__checkbox d-flex align-items-center">
                        <input :id="'service-warranty-' + index" v-model="item.is_service_warranty" type="checkbox"
                          name="check" @change="warrantyChanged(item)">
                        <label class="blueText" :for="'service-warranty-' + index">Labor Warranty</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <button class="btn buttonPrimary serviceBtn" @click="$emit('select-part', item, index)">
                Select Part
              </button>
            </div>
          </div>

          <!-- labor fee -->
          <div class="d-flex align-items-center justify-content-between p-2 lightGreyBg rounded mb-3">
            <span class="blueText">Labor Fee</span>
            <span class="fw-bold blackText">
              {{ item.is_service_warranty ? "Labor Warranty" : "$" + $helper.formatAmount(item.diagnosis_labor_price ?? 0) }}
            </span>
          </div>

          <!-- selected parts -->
          <div v-if="item.parts && item.parts.length > 0" class="selectedParts">
            <h6 class="blueText mb-3">
              Selected Parts:
            </h6>
            <nest_selected_part :item="item" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import nest_selected_part from "./nest_selected_part.vue";

export default {
  components: {
    nest_selected_part,
  },

  props: {
    services: {
      type: Array,
      default: () => [],
    },
  },

  emits: ["edit", "remove", "select-part"],

  computed: {
    ...mapGetters(["bookingServices"]),
  },

  methods: {
    getBookingActions(value) {
      const actions = this.bookingServices?.actions;
      if (!actions) {
        return [];
      }
      return (value == 3 ? actions.required : actions.recommended) ?? [];
    },

    onChange(item) {
      item.booking_action_id = item.selected_service.id;
      if (!item.is_service_warranty) {
        item.diagnosis_labor_price = item.selected_service.price ?? item.diagnosis_labor_price;
      }
      item.is_error = false;
      item.error = "";
    },

    warrantyChanged(item) {
      // No labor price when the labor is under warranty
      if (item.is_service_warranty) {
        delete item.diagnosis_labor_price;
      } else {
        item.diagnosis_labor_price = item.selected_service?.price ?? 0;
      }
    },
  },
};
</script>
